import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * @file autoComplete类型Search Filter
 * @author alfielv
 */
import _ from 'lodash';
import React, { useMemo, useState, useCallback } from 'react';
import { AutoComplete } from '@tencent/spaui';
import message from '../../../Message';
var INPUT_DEBOUNCE_DELAY = 300; // 防抖延迟

// autoComplete类型FilterSearch
var FilterAutoComplete = function FilterAutoComplete(props) {
  var name = props.name,
      title = props.title,
      config = props.config,
      _props$selectOnly = props.selectOnly,
      selectOnly = _props$selectOnly === void 0 ? true : _props$selectOnly,
      searchValue = props.searchValue,
      setSearchValue = props.setSearchValue,
      active = props.active,
      setActive = props.setActive,
      searchFunction = props.searchFunction,
      onFilterDataUpdate = props.onFilterDataUpdate,
      handleFilterDataDelayUpdate = props.handleFilterDataDelayUpdate;

  var _ref = config || {},
      onChangeFromConfig = _ref.onChange,
      onSelectFromConfig = _ref.onSelect,
      onOpenFromConfig = _ref.onOpen,
      _ref$SelectProps = _ref.SelectProps,
      SelectProps = _ref$SelectProps === void 0 ? {} : _ref$SelectProps;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      dataSource = _useState2[0],
      setDataSource = _useState2[1]; // autoComplete数据源
  // 更新autoComplete数据源


  var handleDatasourceUpdate = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(keyword) {
      var retDataSource;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!_.isFunction(searchFunction)) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return searchFunction(keyword);

            case 4:
              _context.t0 = _context.sent;
              _context.next = 8;
              break;

            case 7:
              _context.t0 = [];

            case 8:
              retDataSource = _context.t0;
              setDataSource(retDataSource);
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t1 = _context["catch"](0);
              message.error(_context.t1.message);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [searchFunction]); // 更新DataSource防抖处理。

  var handleDataSourceDelayUpdate = useMemo(function () {
    return _.debounce(handleDatasourceUpdate, INPUT_DEBOUNCE_DELAY);
  }, [handleDatasourceUpdate]); // 更新autoComplete项值

  var handleAutoCompleteChange = useCallback(function (type, value, label) {
    // 显示文案,select项使用label，否则使用value
    var showContent = type === 'SELECT' ? label : value;
    setSearchValue(showContent); // 手输字符触发，且在selectOnly模式。 不触发onFilterDataUpdate（仅在onSelect时触发）。

    if (type === 'INPUT' && selectOnly) {
      handleDataSourceDelayUpdate(value);
      value && setActive(true);
      return;
    } // 手输字符串触发，使用防抖效果handleFilterDataDelayUpdate
    // 同事更新dataSource与active状态


    if (type === 'INPUT') {
      handleFilterDataDelayUpdate === null || handleFilterDataDelayUpdate === void 0 ? void 0 : handleFilterDataDelayUpdate({
        type: 'UPDATE',
        key: name,
        value: value
      });
      handleDataSourceDelayUpdate(value);
      value && setActive(true);
    } // select触发，直接使用onFilterDataUpdate立即更新


    if (type === 'SELECT') {
      onFilterDataUpdate({
        type: 'UPDATE',
        key: name,
        value: value
      });
    }
  }, [name, selectOnly, onFilterDataUpdate, handleFilterDataDelayUpdate, handleDataSourceDelayUpdate, setActive, setSearchValue]);
  return /*#__PURE__*/React.createElement(AutoComplete, _extends({
    value: searchValue,
    data: dataSource,
    filter: false,
    placeholder: "\u8BF7\u8F93\u5165".concat(title),
    clear: false,
    open: active
  }, config, {
    SelectProps: _objectSpread({
      search: false,
      containerStyle: {
        height: 'auto'
      }
    }, SelectProps),
    onChange: function onChange(event, value, valueData) {
      handleAutoCompleteChange('INPUT', value);
      onChangeFromConfig === null || onChangeFromConfig === void 0 ? void 0 : onChangeFromConfig(event, value, valueData);
    },
    onSelect: function onSelect(event, value, label, valueData) {
      handleAutoCompleteChange('SELECT', value, label);
      onSelectFromConfig === null || onSelectFromConfig === void 0 ? void 0 : onSelectFromConfig(event, value, label, valueData);
    },
    onOpen: function onOpen(event, open) {
      setActive(open);
      onOpenFromConfig === null || onOpenFromConfig === void 0 ? void 0 : onOpenFromConfig(event, open);
    }
  }));
};

export default FilterAutoComplete;